import { get } from 'lodash-es';
import { handleActions } from 'redux-actions';
import { IDLE } from 'settings/constants/apiState';
import { appLogoutAction } from 'store/actions/app';
import { requestCalendarStats, setCalendarFiltersAction } from 'store/actions/calendar';

const defaultCalendarTypeOptions = [
  'Task',
  'Milestone',
  'Showing',
  'Offer Expiration',
  'Tour',
  'Closing',
  'Listing Expiration',
  'Project Kickoff',
  'Project Deadline',
];

const initialData = {
  state: IDLE,
  data: [],
  filters: {
    type: defaultCalendarTypeOptions,
    agentsOrOwners: [],
    clients: [],
    transactionIds: [],
  },
};

export default handleActions(
  {
    [requestCalendarStats as any]: (state, { payload }) => ({
      ...state,
      state: payload.state,
      data: get(payload, 'data', initialData.data),
    }),
    [setCalendarFiltersAction as any]: (state, { payload }) => ({
      ...state,
      filters: payload || { type: defaultCalendarTypeOptions },
    }),
    [appLogoutAction as any]: () => initialData,
  },
  initialData as any,
);
